const languages = [
  {
    id: 'eng',
    name: 'English (en)',
  },
  {
    id: 'ar',
    name: 'العربية (ar)',
  },
  {
    id: 'nl',
    name: 'Nederlands (nl)',
  },
  {
    id: 'fr',
    name: 'Français (fr)',
  },
  {
    id: 'de',
    name: 'Deutsch (de)',
  },
  {
    id: 'हिन्दी (hi)',
    name: 'hi',
  },
  {
    id: 'it',
    name: 'Italiano (it)',
  },
  {
    id: 'ja',
    name: '日本語 (ja)',
  },
  {
    id: 'ko',
    name: '한국어 (ko)',
  },
  {
    id: 'pt',
    name: 'Português (pt)',
  },
  {
    id: 'ru',
    name: 'русский (ru)',
  },
  {
    id: 'zh',
    name: '中文 (zh)',
  },
  {
    id: 'es',
    name: 'Español (es)',
  },
  {
    id: 'ml',
    name: 'മലയാളം (ml)',
  },
  {
    id: 'ca',
    name: 'Català (ca)',
  },
  {
    id: 'el',
    name: 'ελληνικά (el)',
  },
  {
    id: 'pt-BR',
    name: 'Português Brasileiro (pt-BR)',
  },
  {
    id: 'ro',
    name: 'Română (ro)',
  },
  {
    id: 'ta',
    name: 'தமிழ் (ta)',
  },
  {
    id: 'fa',
    name: 'فارسی (fa)',
  },
  {
    id: 'zh-TW',
    name: '中文 (台湾) (zh-TW)',
  },
  {
    id: 'vi',
    name: 'Tiếng Việt (vi)',
  },
  {
    id: 'da',
    name: 'dansk (da)',
  },
  {
    id: 'tr',
    name: 'Türkçe (tr)',
  },
  {
    id: 'cs',
    name: 'čeština (cs)',
  },
  {
    id: 'fi',
    name: 'suomi, suomen kieli (fi)',
  },
  {
    id: 'id',
    name: 'Bahasa Indonesia (id)',
  },
  {
    id: 'sv',
    name: 'Svenska (sv)',
  },
  {
    id: 'hu',
    name: 'magyar nyelv (hu)',
  },
  {
    id: 'no',
    name: 'norsk (no)',
  },
  {
    id: 'zh-CN',
    name: '中文 (zh-CN)',
  },
  {
    id: 'pl',
    name: 'język polski (pl)',
  },
];

export default languages;
